import { render } from "./FactoriesTable.vue?vue&type=template&id=d965e000"
import script from "./FactoriesTable.vue?vue&type=script&lang=js"
export * from "./FactoriesTable.vue?vue&type=script&lang=js"

import "./FactoriesTable.vue?vue&type=style&index=0&id=d965e000&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__